import Interceptor from '../Interceptor'
import Env from '../../services/Env'

export default class InterceptorAuth {
  api: any = new Interceptor()
  config: object = {
    baseURL: Env.API_FINX_AUTH + 'api/',
  }

  get(url: string): any {
    return this.api.get(url, this.config)
  }

  delete(url: string): any {
    return this.api.delete(url, this.config)
  }

  post(url: string, data: any): any {
    return this.api.post(url, data, this.config)
  }

  put(url: string, data: any): any {
    return this.api.put(url, data, this.config)
  }
}
